import { Component } from '@mycolorway/tao';
import moment from 'moment';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { DatePickerFieldResult } from '../date-picker-field';

Component('tr-todo-date-field-result', {
  mixins: [eventListenerMixin],

  extends: [DatePickerFieldResult],

  properties: {
    shortened: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.selectedResult = this.querySelector('.selected-text tr-readable-datetime');
    this.nativeStartAt = this.querySelector('.native-control-wrapper .start-at-input');
    this.nativeDueAt = this.querySelector('.native-control-wrapper .due-at-input');
  },

  setSelected(dates) {
    if (!dates || dates.length === 0) {
      this.clearSelected();
    } else {
      this.selected = true;

      const formattedDates = dates.map(date => moment(date).format());
      if (this.selectedResult) {
        if (this.shortened && dates.length === 2) {
          this.selectedResult.format = 'MM/DD';
        } else {
          this.selectedResult.format = '';
        }

        this.selectedResult.date = formattedDates.join(',');
      }

      if (this.nativeStartAt && this.nativeDueAt) {
        if (dates.length === 1) formattedDates.unshift(null);
        [this.nativeStartAt.value, this.nativeDueAt.value] = formattedDates;
      }
    }
  },

  clearSelected() {
    this.selected = false;
    if (this.selectedResult) {
      this.selectedResult.textContent = '';
      this.selectedResult.date = '';
    }

    if (this.nativeStartAt) this.nativeStartAt.value = '';
    if (this.nativeDueAt) this.nativeDueAt.value = '';
  },
});
